// Subscription actions on My Account → Payments → Subscription:
// cancel (with confirm overlay — stops the Cashfree mandate, access runs to
// period end) and retry payment (raises a charge on the mandate after a
// failed auto-debit; confirmation arrives via the backend webhook).
document.addEventListener('DOMContentLoaded', () => {
    const page = document.querySelector('.myaccount');
    if (!page) return;

    let busy = false;

    function notify(message, type) {
        const note = document.createElement('div');
        note.textContent = message;
        note.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);'
            + 'z-index:100000;padding:12px 24px;border-radius:8px;color:#fff;font-size:14px;'
            + 'box-shadow:0 4px 12px rgba(0,0,0,.3);'
            + 'background:' + (type === 'success' ? '#28a745' : '#d9534f') + ';';
        document.body.appendChild(note);
        setTimeout(() => note.remove(), 5000);
    }

    // Confirm overlay — same design family as the profile-updated / KYC modals.
    function showCancelConfirm(hint, onConfirm) {
        const uid = 'subscription-cancel-modal';
        if (document.getElementById(uid)) return;

        const overlay = document.createElement('div');
        overlay.id = uid;
        overlay.className = 'sna-modal';
        overlay.style.cssText = 'position:fixed;inset:0;z-index:100001;background:rgba(0,0,0,.6);'
            + 'backdrop-filter:blur(8px);-webkit-backdrop-filter:blur(8px);'
            + 'display:flex;align-items:center;justify-content:center;padding:20px;font-family:inherit;';
        overlay.innerHTML =
            '<div class="sna-modal__card" style="position:relative;background-color:rgba(23,23,27,.72);'
            +   'backdrop-filter:blur(18px) saturate(140%);-webkit-backdrop-filter:blur(18px) saturate(140%);'
            +   'border:1px solid rgba(255,255,255,.1);'
            +   'border-radius:24px;max-width:560px;width:100%;padding:44px;text-align:center;'
            +   'box-shadow:0 24px 64px rgba(0,0,0,.55);">'
            +   '<button type="button" data-close aria-label="Close" style="position:absolute;top:18px;right:20px;background:none;border:none;cursor:pointer;color:#f97316;font-size:24px;line-height:1;padding:4px;">&times;</button>'
            +   '<h3 style="font-size:24px;color:#fff;margin:0 0 16px;font-weight:600;line-height:1.3;">Cancel your All-Access pass?</h3>'
            +   '<p data-hint style="font-size:15px;color:#9a9aa2;margin:0 0 28px;"></p>'
            +   '<div style="display:flex;gap:12px;justify-content:center;flex-wrap:wrap;">'
            +     '<button type="button" data-close style="padding:10px 22px;border-radius:8px;border:1px solid #26262b;background:none;color:#fff;cursor:pointer;">Keep subscription</button>'
            +     '<button type="button" data-confirm style="padding:10px 22px;border-radius:8px;border:none;background:#d9534f;color:#fff;cursor:pointer;">Yes, cancel</button>'
            +   '</div>'
            + '</div>';

        overlay.querySelector('[data-hint]').textContent =
            hint || "You'll keep access until the end of the current period, then your subscription won't renew. Autopay stops immediately.";

        document.body.appendChild(overlay);
        document.body.style.overflow = 'hidden';
        function close() { overlay.remove(); document.body.style.overflow = ''; }
        overlay.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', close));
        overlay.addEventListener('click', (ev) => { if (ev.target === overlay) close(); });
        overlay.querySelector('[data-confirm]').addEventListener('click', () => {
            close();
            onConfirm();
        });
    }

    // Re-render the payments tab with a cache-buster: a plain re-navigation
    // to the same URL can be served from the browser's HTTP cache, which is
    // exactly the stale-panel bug this avoids.
    function refreshPanel(delayMs) {
        setTimeout(() => {
            window.location.assign('/myaccount?tab=payments&pay=subscription&_=' + Date.now());
        }, delayMs);
    }

    function cancelSubscription(button) {
        busy = true;
        button.disabled = true;
        button.innerHTML = '<i class="ri-loader-4-line"></i> Cancelling…';

        fetch('/api/payment/subscription_cancel', {
            method: 'POST',
            credentials: 'same-origin'
        })
        .then((resp) => resp.json().then((body) => ({ ok: resp.ok, body })))
        .then((result) => {
            if (!result.ok || !result.body || result.body.status === 0) {
                busy = false;
                button.disabled = false;
                button.innerHTML = '<i class="ri-close-circle-line"></i> Cancel subscription';
                notify((result.body && result.body.error) || 'Unable to cancel the subscription. Please try again.', 'error');
                return;
            }

            // Optimistic in-place flip so the panel updates instantly —
            // the cache-busted refresh then renders the authoritative state.
            const section = document.querySelector('.myaccount__subscription');
            if (section) {
                const pill = section.querySelector('.myaccount__pay-pill');
                if (pill) {
                    pill.textContent = 'Cancelling';
                    pill.className = 'myaccount__pay-pill myaccount__pay-pill--warning';
                }
                section.querySelectorAll('[data-sub-action]').forEach((b) => b.remove());
            }

            notify('Subscription cancelled — autopay stopped. Access continues until the period end.', 'success');
            refreshPanel(900);
        })
        .catch((err) => {
            console.error('Subscription cancel failed:', err);
            busy = false;
            button.disabled = false;
            button.innerHTML = '<i class="ri-close-circle-line"></i> Cancel subscription';
            notify('Network error. Please try again.', 'error');
        });
    }

    function retryPayment(button) {
        busy = true;
        button.disabled = true;

        fetch('/api/payment/subscription_renew', {
            method: 'POST',
            credentials: 'same-origin'
        })
        .then((resp) => resp.json().then((body) => ({ ok: resp.ok, body })))
        .then((result) => {
            if (!result.ok || !result.body || result.body.status === 0) {
                busy = false;
                button.disabled = false;
                notify((result.body && result.body.error) || 'Unable to retry the payment. Please try again.', 'error');
                return;
            }
            // The charge rides the mandate; the webhook confirms it — no pay
            // page. Refresh (cache-busted) so the panel reflects the pending retry.
            // Cashfree only honours the date portion of a retry schedule and
            // requires it to be in the future, so the charge runs the next day —
            // say when rather than implying it happens now.
            var retryData = result.body.data || {};
            notify(retryData.message
                || (retryData.scheduled_for_label
                    ? 'Payment retry scheduled for ' + retryData.scheduled_for_label
                      + '. We\'ll email you as soon as your bank confirms it.'
                    : 'Payment retry scheduled. We\'ll email you as soon as your bank confirms it.'),
                'success');
            refreshPanel(2000);
        })
        .catch((err) => {
            console.error('Subscription payment retry failed:', err);
            busy = false;
            button.disabled = false;
            notify('Network error. Please try again.', 'error');
        });
    }

    page.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-sub-action]');
        if (!btn || busy) return;
        e.preventDefault();

        const action = btn.dataset.subAction;
        if (action === 'cancel') {
            showCancelConfirm(btn.dataset.cancelHint, () => cancelSubscription(btn));
        } else if (action === 'renew') {
            retryPayment(btn);
        }
    });
});
